module.exports = __webpack_public_path__ + "static/media/AmanDevBlog.8b6af46b.png";